/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 25/5/2023
 */

import { Provider } from 'react-redux';
import './App.css';
import { StyledEngineProvider, ThemeProvider } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import { RootStore } from './Store/RootStore';
import Theme from './Theme/Theme';
import PageRoutes from './Routes/PageRoutes';
import { SessionTimeout } from './Components/Timeout/SessionTimeout';
import React from 'react';
import ScrollToTop from './Components/Shared/ScrollToTop';

function App() {

  const [isSignedIn, setIsSignedIn] = React.useState(false)

  React.useEffect(() => {
    const getIsSignedIn = () => {
      if (typeof window !== undefined) {
        const signed = sessionStorage.getItem("isSignedIn")
        setIsSignedIn(signed)
      }
    }
    getIsSignedIn()
  }, [isSignedIn])

  return (
    <Provider store={RootStore}>
      <ThemeProvider theme={Theme}>
        <StyledEngineProvider injectFirst>
        <ScrollToTop>
          <ToastContainer hideProgressBar theme="colored" autoClose={1000} limit={2}/>
          <PageRoutes />
          {isSignedIn=="1" && <SessionTimeout />}
        </ScrollToTop>
        </StyledEngineProvider>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
